import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactSVG from 'react-svg';
import { Avatar } from '@material-ui/core';
import { CallIcon, TransferIcon } from '~/assets/svgIcons';
import { useControlSessions } from '~/hooks';
import * as lib from '~/dependencies';
import { strcmp, formatNumber } from '~/helpers';
import * as actions from '~/store/actions';
import {
  DivRow,
  Row,
  IconButtonComponent,
  NameNumber,
  BoxData,
  BarDotted,
  MenuContainer,
  ButtonField,
  MenuItemComponent,
} from './styles';

const countries = require('~/assets/countries/countries.json');

const allCountries = Object.keys(countries).reduce(
  (prev, next) =>
    prev.concat({
      code: next,
      callingCode: countries[next].callingCode,
      flag: countries[next].flag,
      name: countries[next].name.common,
    }),
  []
);

export default function RowList({
  selectContact,
  match,
  item,
  tab,
  tryToCall,
  contactItemIndex,
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const dispatch = useDispatch();
  const controlSessions = useControlSessions();
  const { t } = lib.useTranslation();

  const [openMenu, setOpenMenu] = useState(false);

  const currentCalls = useSelector(state => state?.callCurrent?.data);
  const activeSession = useSelector(state => state?.callCurrent?.session);
  const currentSessionId = useSelector(state =>
    state.callCurrent && state.callCurrent.session
      ? state.callCurrent.session.id
      : null
  );

  const activeSessionInfo = useSelector(state =>
    state.callCurrent && state.callCurrent.session
      ? state.callCurrent.data.find(e => e.id === state.callCurrent.session.id)
      : {}
  );

  const totalCalls = useSelector(state =>
    state?.callCurrent?.data?.length ? state?.callCurrent?.data?.length : 0
  );

  function findFlag(code) {
    const countryIndex = allCountries.findIndex(e => e.callingCode === code);
    const flagSelected =
      countryIndex !== -1 ? allCountries[countryIndex].flag : [];

    return flagSelected;
  }

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  }

  function handleClose() {
    setAnchorEl(null);
    setOpenMenu(false);
  }

  function call(number, name, contactId) {
    setAnchorEl(null);
    setOpenMenu(false);
    tryToCall(number, { name, contactId });
  }

  function blindTransfer(number) {
    if (number.length > 0 && currentSessionId) {
      controlSessions(currentSessionId, 'blindtransfer', number);
    }
  }

  function attendedTransfer(number) {
    if (number.length > 0 && currentSessionId) {
      controlSessions(currentSessionId, 'hold');
      controlSessions(currentSessionId, 'waitingTransfer');
      controlSessions(currentSessionId, 'invite', number, {
        transferOff: true,
      });
      dispatch(actions.numberContactToTransfer(number));
    }
  }

  function conferenceCall(number) {
    const callId = currentCalls.findIndex(e => e.id === activeSession.id);

    if (number) {
      if (!currentCalls[callId].hold) {
        controlSessions(activeSession.id, 'hold');
      }
      controlSessions(activeSession.id, 'invite', String(number), {
        waitingToMergeConf: true,
      });
      controlSessions(activeSession.id, 'conferenceOn');
    }
  }

  const flagMobile = item.mobile && formatNumber(item.mobile, 'countryCode');
  const flagLandline = item.mobile && formatNumber(item.mobile, 'countryCode');
  const mobile = item.mobile && formatNumber(item.mobile, 'formatInt');
  const landline = item.landline && formatNumber(item.landline, 'formatInt');

  useEffect(() => {
    if (!activeSessionInfo?.callActions?.transfer) {
      setOpen(false);
    }
  }, [activeSessionInfo, setOpen]);

  return (
    <DivRow>
      <Row
        onClick={
          activeSessionInfo?.callActions?.transfer
            ? () => setOpen(!open)
            : () => {}
        }
        border={open}>
        <lib.Link
          style={{ display: 'flex', flex: 1 }}
          to={
            !activeSessionInfo?.callActions?.transfer
              ? {
                  pathname: `${match.path}/contactDetails/${item.id}`,
                  state: {
                    id: item.id,
                    tab,
                    contactItemIndex,
                  },
                }
              : {}
          }>
          <BoxData>
            <div style={{ marginRight: 10 }}>
              <Avatar className="avatar">
                <span>
                  {item.name ? item.name.slice(0, 2).toUpperCase() : '-'}
                </span>
              </Avatar>
            </div>
            <NameNumber>
              <span className="TextMain">
                {strcmp(item.name, 'Undefined') ||
                  item.mobile ||
                  item.landline ||
                  item.email ||
                  item.id}
              </span>
            </NameNumber>
          </BoxData>
        </lib.Link>

        <div className="actions">
          {!selectContact && (
            <>
              {!activeSessionInfo?.callActions?.transfer &&
                (landline || mobile) && (
                  <IconButtonComponent
                    aria-label="Call"
                    onClick={handleClick}
                    aria-controls={`long-menu-${item.id}`}
                    aria-haspopup="true">
                    <ReactSVG src={CallIcon} className="call-icon" />
                  </IconButtonComponent>
                )}
              <MenuContainer
                id={`long-menu-${item.id}`}
                anchorEl={anchorEl}
                keepMounted
                open={openMenu}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    width: 200,
                  },
                }}>
                {landline && (
                  <MenuItemComponent
                    className="itens-menu"
                    onClick={() =>
                      totalCalls >= 2
                        ? {}
                        : call(
                            item.landline,
                            item.name || null,
                            item.id || null
                          )
                    }
                    disabled={totalCalls >= 2}>
                    {landline && (
                      <div className="row">
                        <div className="left">
                          <span>{t('screens.contacts.landline')}</span>
                          <span>
                            {flagLandline && (
                              <img src={findFlag(flagLandline)} alt="mobile" />
                            )}
                            {landline}
                          </span>
                        </div>
                        <div className="right">
                          <ButtonField>
                            <ReactSVG src={CallIcon} className="call-icon" />
                          </ButtonField>
                        </div>
                      </div>
                    )}
                  </MenuItemComponent>
                )}
                {mobile && (
                  <MenuItemComponent
                    className="itens-menu"
                    onClick={() =>
                      totalCalls >= 2
                        ? {}
                        : call(item.mobile, item.name || null, item.id || null)
                    }
                    disabled={totalCalls >= 2}>
                    <div className="row">
                      <div className="left">
                        <span>{t('screens.contacts.mobile')}</span>
                        <span>
                          {flagMobile && (
                            <img src={findFlag(flagMobile)} alt="mobile" />
                          )}
                          {mobile}
                        </span>
                      </div>
                      <div className="right">
                        <ButtonField>
                          <ReactSVG src={CallIcon} className="call-icon" />
                        </ButtonField>
                      </div>
                    </div>
                  </MenuItemComponent>
                )}
              </MenuContainer>
            </>
          )}
        </div>
      </Row>

      {open && (
        <>
          {mobile && (
            <>
              <BarDotted />
              <Row selectContact={selectContact} border={selectContact}>
                <div className="info">
                  <div className="title">
                    {flagMobile && (
                      <img src={findFlag(flagMobile)} alt="mobile" />
                    )}
                    <span>{t('screens.contacts.mobile')}</span>
                  </div>
                  <span className="number">{mobile}</span>
                </div>
                <div className="transfer-actions">
                  {activeSessionInfo?.callActions?.transfer && (
                    <button
                      type="submit"
                      className="call-transfer"
                      onClick={() => blindTransfer(item.mobile)}>
                      <ReactSVG src={TransferIcon} />
                      <span className="txt-transfer">
                        {t('screens.contacts.components.rows.btnTransfer')}
                      </span>
                    </button>
                  )}
                  {activeSessionInfo?.callActions?.transfer && (
                    <button
                      type="submit"
                      className="call-transfer"
                      onClick={() => attendedTransfer(item.mobile)}>
                      <ReactSVG src={TransferIcon} />
                      <span className="txt-transfer">
                        {t('screens.contacts.components.rows.btnCallFirst')}
                      </span>
                    </button>
                  )}
                  {activeSessionInfo?.callActions?.conference && (
                    <button
                      type="submit"
                      className="call-transfer"
                      onClick={() => conferenceCall(item.mobile)}>
                      <ReactSVG src={TransferIcon} />
                      <span className="txt-transfer">
                        {t('screens.contacts.components.rows.btnCallFirst')}
                      </span>
                    </button>
                  )}
                </div>
              </Row>
            </>
          )}

          {landline && (
            <>
              <BarDotted />
              <Row selectContact={selectContact} border={selectContact}>
                <div className="info">
                  <div className="title">
                    {flagLandline && (
                      <img src={findFlag(flagLandline)} alt="Landline" />
                    )}
                    <span>{t('screens.contacts.landline')}</span>
                  </div>
                  <span className="number">{landline}</span>
                </div>
                <div className="transfer-actions">
                  {activeSessionInfo && (
                    <button
                      type="submit"
                      className="call-transfer"
                      onClick={() => blindTransfer(item.landline)}>
                      <ReactSVG src={TransferIcon} />
                      <span className="txt-transfer">
                        {t('screens.contacts.components.rows.btnTransfer')}
                      </span>
                    </button>
                  )}
                  {activeSessionInfo && (
                    <button
                      type="submit"
                      className="call-transfer"
                      onClick={() => attendedTransfer(item.landline)}>
                      <ReactSVG src={TransferIcon} />
                      <span className="txt-transfer">
                        {t('screens.contacts.components.rows.btnCallFirst')}
                      </span>
                    </button>
                  )}
                </div>
              </Row>
            </>
          )}
        </>
      )}
    </DivRow>
  );
}

RowList.defaultProps = {
  match: [],
  item: [],
  tryToCall: () => {},
  selectContact: false,
  tab: 0,
  contactItemIndex: 0,
};

RowList.propTypes = {
  match: lib.PropTypes.instanceOf(Object),
  item: lib.PropTypes.instanceOf(Object),
  tryToCall: lib.PropTypes.func,
  selectContact: lib.PropTypes.bool,
  tab: lib.PropTypes.number,
  contactItemIndex: lib.PropTypes.number,
};
